export interface ISessionState {
    id: string;
    userName: string;
    fullName: string;
    accessToken: string;
    refreshToken: string;
    refreshTime: number;
    employeeGroupParameters: EmployeeGroupParameters;
    defaultCulture: string;
}

export class SessionState implements ISessionState {
    id: string;
    userName: string;
    fullName: string;
    accessToken: string;
    refreshToken: string;
    refreshTime: number;
    employeeGroupParameters: EmployeeGroupParameters;
    defaultCulture: string;

    constructor();
    constructor(obj: ISessionState);
    constructor(obj?: any) {
        this.id = obj?.id || "";
        this.userName = obj?.userName || "";
        this.fullName = obj?.fullName || "";
        this.accessToken = obj?.accessToken || "";
        this.refreshToken = obj?.refreshToken || "";
        this.refreshTime = obj?.refreshTime || 0;
        this.employeeGroupParameters = obj?.employeeGroupParameters || {};
        this.defaultCulture = obj?.defaultCulture || "";
    }
}

interface EmployeeGroupParameters {
    isWorkQueueInUse: boolean;
    usesLocationData: boolean;
    canCreateWorkOrderInMobile: boolean;
    canEditWorkEntries: boolean;
    canAddAndEditDayBookings: boolean;
    showWorkShiftEndTimesInMobile: boolean;
    isCommentRequiredWhenEditingWorkTime: boolean;
}
